import Vue from 'vue';
import store from './store';

// imported components
import Modal from '@/components/bootstrap/Modal.vue';
import Stars from '@/components/micro_components/Stars.vue';
import Medals from '@/components/micro_components/Medals.vue';
import Datepicker from 'vuejs-datepicker/dist/vuejs-datepicker.esm';
import Tooltip from 'vue-directive-tooltip'; // Revisar si es necesario.
import VCalendar from 'v-calendar';
import fullscreen from 'vue-fullscreen';
import ToggleButton from 'vue-js-toggle-button'; // Revisar si es necesario.
import IdleVue from 'idle-vue';
import VPopover from 'vue-js-popover'; // Revisar si es necesario.
import EventActivity from '@/plugins/event-activity';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';

import {
  Loading,
  Notification,
  Dialog,
  Option,
  Select,
  OptionGroup,
  Form,
  FormItem,
  Input,
  Button,
  Switch,
  Slider,ElDialog
} from 'element-ui';
const eventsHub = new Vue();

// sync(store, router); // done. Returns an unsync callback fn
Vue.component('datepicker', Datepicker);
Vue.component('tpm-modal', Modal);
Vue.component('star', Stars);
Vue.component('medals', Medals);
Vue.use(EventActivity);
Vue.use(Tooltip);
Vue.use(fullscreen);
Vue.use(ToggleButton);
Vue.use(VPopover, { tooltip: true });
Vue.use(VCalendar, {
  formats: {
    title: 'MMMM YYYY',
    weekdays: 'W',
    navMonths: 'MMM',
    input: ['L', 'YYYY-MM-DD', 'YYYY/MM/DD'],
    dayPopover: 'L',
  },
});

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 3600000, //close session after 1 hour of inactivity
  store,
  startAtIdle: false,
});
Vue.use(Loading.directive);
Vue.use(Dialog);
Vue.use(Option);
Vue.use(Select);
Vue.use(OptionGroup);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Switch);
Vue.use(Button);
Vue.use(Slider);
locale.use(lang);
Vue.prototype.$notify = Notification;
